<template>
  <div>
    <div>
      <div></div>
      <div class="px-5 pb-4">
        <div class="primary--text title">ข้อมูลสาขา</div>
        <v-layout row wrap class="ma-0 mt-3">
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Short name</div>
            <div>{{ detaildata.short_name }}</div>
          </v-flex>

          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Name</div>
            <div>{{ detaildata.branch_name }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Location Group (Name)</div>
            <div>{{ detaildata.location_group }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">ชนิดร้าน</div>
            <div>{{ detaildata.type_store }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">ภาค</div>
            <div>{{ detaildata.zone }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">จังหวัด</div>
            <div>{{ detaildata.province }}</div>
          </v-flex>
          <v-flex xs12 class="mb-2">
            <div class="caption grey--text">Address</div>
            <div>{{ detaildata.address }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">ห้าง/อาคาร</div>
            <div>{{ detaildata.building }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">สถานที่</div>
            <div>{{ detaildata.place }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Google Maps</div>
            <div>{{ detaildata.google_maps ? detaildata.google_maps : '-' }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">สถานที่ใกล้เคียง</div>
            <div>{{ detaildata.nearby_place ? detaildata.nearby_place : '-' }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">latitude</div>
            <div>{{ detaildata.latitude ? detaildata.latitude : '-' }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">longitude</div>
            <div>{{ detaildata.longitude ? detaildata.longitude : '-' }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Open time</div>
            <div>{{ detaildata.open_times ? detaildata.open_times : '-' }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Close time</div>
            <div>{{ detaildata.close_times ? detaildata.close_times : '-' }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Tel</div>
            <div>{{ detaildata.tel ? detaildata.tel : '-' }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">ID</div>
            <div>{{ detaildata.branch_id ? detaildata.branch_id : '-' }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">BU</div>
            <div>{{ detaildata.bu ? detaildata.bu : '-' }}</div>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['detaildata'],
  data() {
    return {
      items: []
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket2/productandbranch/BranchDetail.vue